import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingRight: 3,
    // minWidth: 180,
    // maxWidth: 245,
    width: 216,
  },
  card: {
    display: "flex",
    padding: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(0.5),
  },
  count: {
    fontSize: 56,
    lineHeight: 1,
    fontWeight: theme.typography.fontWeightLight,
    textAlign: "right",
  },
  chart: {
    width: "100%",
  },
}));
